import encode from "../server/api/encode";

/**
 * 缓存加解密-各项目用独立的对象储存缓存-medicalTools
 */
let storageByCode = function (key, body) {
  if (!body) {// 取
    let res = {}
    let medicalTools = localStorage.getItem('medicalTools')
    if (medicalTools) { 
      let decodeMedicalTools = encode.decodeFuc(medicalTools)
      res = JSON.parse(decodeMedicalTools)
    }
    return res[key]
  } else {// 存
    // 校验是否已有缓存对象
    let medicalTools = {}
    if (!localStorage.getItem('medicalTools')) {
      medicalTools[key] = body
    } else {
      medicalTools = JSON.parse(encode.decodeFuc(localStorage.getItem('medicalTools')))
      medicalTools[key] = body
    }
    // 存入项目缓存对象
    let encodeBody = encode.encodeFunc(medicalTools)
    localStorage.setItem('medicalTools', encodeBody.data)
  }
}

export default storageByCode


// WEBPACK FOOTER //
// ./src/utils/storageByCode.js